import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { SocialMedia } from '../../model/socialmedia';
import { NetworkService } from '../../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaSocialMediaHttpService extends GenericAkitaHTTPService<SocialMedia> {
  constructor(http: HttpClient, networkService: NetworkService) {

    const options: HttpOptions = {
      params: {
        type: 'SocialMedia',
        options: 'keyValues',
        limit: '50',
        orderBy: '!dateIssued'
      }
    };
    super(http, networkService, '/v2/entities/', 'socialmedia', options);
  }
}
